<template>
  <div>
    <v-row
      no-gutters
      v-for="(footerRow, rowIdx) in footerRows"
      :key="rowIdx"
      style="padding: 1px 0"
    >
      <v-col
        v-for="(footer, idx) in footerRow"
        :key="idx"
        :cols="footer.cols"
        :class="footer.class"
        class="align-self-center"
      >
        <span v-if="footer.display_text">
          {{ footer.display_text }}
        </span>
        <span v-if="footer.display_text && footer.field">
          {{ $t("Global.colon") }}
        </span>
        {{ $printUtils.getValue(data, footer) }}
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.align-self-center {
    align-self: center !important;
}
</style>

<script>
export default {
  props: {
    footerRows: Array,
    data: Object,
  },
};
</script>